
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/groupCategory';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"group-category-summary__search\">\n      <input\n        type=\"text\"\n        class=\"filterable search-query\"\n        placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category.search_groups", "Search groups", options) : helperMissing.call(depth0, "t", "groups.manage.group_category.search_groups", "Search groups", options)))
    + "\"\n        aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category.search_groups", "Search groups", options) : helperMissing.call(depth0, "t", "groups.manage.group_category.search_groups", "Search groups", options)))
    + "\"\n        role=\"search\"\n      >\n    </div>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "group-category-contents-condensed";
  }

function program5(depth0,data) {
  
  
  return "\n    <div class=\"progress-container\" id=\"group-category-progress\"></div>\n  ";
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.IS_LARGE_ROSTER), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program8(depth0,data) {
  
  
  return "\n      <div class=\"groups\" data-view=\"groups\"></div>\n    ";
  }

function program10(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n      <div class=\"row-fluid\">\n        <div class=\"span3 unassigned-students\">\n          <h2 class=\"unassigned-users-heading group-heading\"></h2>\n          <input\n            type=\"search\"\n            class=\"ic-Input filterable-unassigned-users search-query\"\n            placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category.search_users", "Search users", options) : helperMissing.call(depth0, "t", "groups.manage.group_category.search_users", "Search users", options)))
    + "\"\n            aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category.search_users", "Search users", options) : helperMissing.call(depth0, "t", "groups.manage.group_category.search_users", "Search users", options)))
    + "\"\n          >\n          <div data-view=\"unassignedUsers\"></div>\n        </div>\n        <div class=\"span9 groups\">\n          <h2 class=\"group-heading groups-with-count\"></h2>\n          <div data-view=\"groups\"></div>\n        </div>\n      </div>\n    ";
  return buffer;
  }

  buffer += "<span class=\"accessibility-warning\" tabindex=\"0\"> Warning: for improved accessibility assigning students to groups, please use the Move To Dialog option found in the menu.</span>\n\n<div class=\"group-category-summary\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.groupsAreSearchable), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <div class=\"group-category-summary__detail\" data-view=\"groupCategoryDetail\"></div>\n</div>\n\n<div class=\"group-category-contents ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.IS_LARGE_ROSTER), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.groupCreationInProgress), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '67',
      bundle: 'jst/groups/manage/groupCategory'
    });
  ;
    export default templates[name];
  